export const config = {
  ...globalThis.EnvConfig.api
}
